import './SimpleDivider.css';

export default function SimpleDivider() {
  return <div className="simple-divider"></div>;
}
